import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Briefcase } from "lucide-react";

const WystepNaSpotkaniuFirmowym = () => (
  <SeoPageLayout title="Występ komediowy na" titleAccent="spotkaniu firmowym">
    <SeoSection title="Stand-up na spotkaniu firmowym">
      <p>Spotkania firmowe - kwartalne podsumowania, town halle, kickoffy projektowe - to momenty, które kształtują kulturę organizacyjną. Profesjonalny występ komediowy na spotkaniu firmowym przełamuje rutynę, energetyzuje zespół i buduje poczucie wspólnoty. Zamiast kolejnej prezentacji PowerPoint - daj ludziom coś, co naprawdę zapamiętają.</p>
    </SeoSection>
    <SeoSection title="Rodzaje spotkań firmowych">
      <SeoStyledList items={[
        "Town hall meetings i all-hands",
        "Kwartalne i roczne podsumowania",
        "Kickoffy nowych projektów i strategii",
        "Spotkania działowe i międzydziałowe",
        "Onboardingi nowych pracowników",
        "Spotkania po fuzjach i zmianach organizacyjnych"
      ]} />
    </SeoSection>
    <SeoSection title="Dlaczego humor na spotkaniu firmowym?">
      <p>Badania pokazują, że humor w miejscu pracy zwiększa zaangażowanie, poprawia retencję informacji i buduje zaufanie w zespole. Krótki, 15-30 minutowy występ komediowy może być idealnym przerywnikiem między sesjami merytorycznymi lub punktem kulminacyjnym spotkania, który pozostawi pozytywne wrażenie u wszystkich uczestników.</p>
      <SeoHighlightBox icon={Briefcase}>
        Już 15-minutowy występ komediowy potrafi odmienić atmosferę spotkania i zwiększyć zaangażowanie zespołu.
      </SeoHighlightBox>
    </SeoSection>
    <SeoSection title="Zamów komika na spotkanie firmowe">
      <p>Skontaktuj się z nami i opowiedz o swoim spotkaniu - agenda, uczestnicy, cel. Zaproponujemy format, który idealnie wpasuje się w program i wzmocni przekaz Twojego spotkania, dodając mu lekkości i energii.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default WystepNaSpotkaniuFirmowym;
